import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { format } from 'date-fns';

const AlertsPanel = ({ alerts }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-xl border border-border p-4 sm:p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading font-semibold text-foreground flex items-center gap-2">
          <Icon name="AlertTriangle" size={20} strokeWidth={2} />
          Critical Alerts
        </h2>
        <button
          onClick={() => navigate('/critical-alerts-dashboard')}
          className="text-sm text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1"
        >
          View All
          <Icon name="ChevronRight" size={16} strokeWidth={2} />
        </button>
      </div>

      {alerts?.length === 0 ? (
        <div className="text-center py-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-green-50 mb-3">
            <Icon name="CheckCircle" size={24} strokeWidth={2} className="text-green-600" />
          </div>
          <p className="text-sm text-muted-foreground">No critical alerts at this time</p>
        </div>
      ) : (
        <div className="space-y-3">
          {alerts?.slice(0, 5)?.map((alert, index) => (
            <div
              key={index}
              className="bg-red-50 border border-red-200 rounded-lg p-4 hover:bg-red-100 transition-colors cursor-pointer"
              onClick={() => navigate('/critical-alerts-dashboard')}
            >
              <div className="flex items-start gap-3">
                <Icon name="AlertCircle" size={20} strokeWidth={2} className="text-red-600 flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-red-900 mb-1">
                    {alert?.alert_type?.replace('_', ' ')?.toUpperCase()}
                  </p>
                  <p className="text-sm text-red-700 mb-2">{alert?.message}</p>
                  <p className="text-xs text-red-600">
                    {format(new Date(alert?.created_at), 'MMM dd, yyyy HH:mm')}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AlertsPanel;